import { v4 as uuid } from "uuid";
import { toTime, isWithinTimeRange } from "@/helpers/tools";
import { TIME_PERIOD_FILTERS, FILTER_ID, FILTER_TYPE, DAY_PERIODS, PARTS_OF_DAY, LABELS } from "@/constantData";

// message list mapper
export const messageListMapper = (messages) => {
  return messages.map((message) => {
    return {
      ...message,

      key: uuid(),
    };
  });
};

export const filtersMapper = (results) => {
  const filters = Object.values(FILTER_ID).map((filterId) => {
    switch (filterId) {
      case FILTER_ID.NIGHTS_OF_STAY:
        const accommodationFilterValues = Array.from(
          new Set(results.map(tour => tour.numberOfNightsOfStay)),
          numberOfNightsOfStay => ({
            id: uuid(),
            title: `${numberOfNightsOfStay}شب`,
            value: numberOfNightsOfStay
          })
        );

        return {
          id: filterId,
          title: 'مدت اقامت (شب)',
          type: FILTER_TYPE.LIST,
          values: accommodationFilterValues,
          selectedValues: []
        }

      case FILTER_ID.WENT_TIME:
        return {
          id: filterId,
          title: 'ساعت رفت',
          type: FILTER_TYPE.LIST,
          values: TIME_PERIOD_FILTERS,
          selectedValues: []
        }

      case FILTER_ID.RETURN_TIME:
        return {
          id: filterId,
          title: 'ساعت برگشت',
          type: FILTER_TYPE.LIST,
          values: TIME_PERIOD_FILTERS,
          selectedValues: []
        }

      case FILTER_ID.HOTEL_STARS:
        const hotelStarsFilterValue = Array.from(
          new Set(results.flatMap((tour) => tour.hotelsStarRate)),
          hotelsStarRate => ({
            id: uuid(),
            title: `${hotelsStarRate} ستاره`,
            value: hotelsStarRate
          })
        ).sort((a, b) => a.value - b.value);

        return {
          id: filterId,
          title: 'ستاره هتل',
          type: FILTER_TYPE.LIST,
          values: hotelStarsFilterValue,
          selectedValues: []
        }

      case FILTER_ID.AIRLINE:
        const uniqueAirlines = Array.from(
          results
            .flatMap(item => item.airLines)
            .reduce((map, airline) => {
              if (!map.has(airline.airLineCode)) {
                map.set(airline.airLineCode, { ...airline, value: airline.airLineCode, id: uuid() });
              }
              return map;
            }, new Map()).values()
        );

        return {
          id: filterId,
          title: 'ایرلاین',
          type: FILTER_TYPE.LIST,
          values: uniqueAirlines,
          selectedValues: []
        }

      case FILTER_ID.PRICE_RANGE:
        // sort incremental
        const prices = results.map(results => Number(results.totalPrice)).sort((a, b) => a - b)

        return {
          id: filterId,
          title: 'قیمت',
          type: FILTER_TYPE.RANGE,
          min: prices[0],
          max: prices[prices.length - 1],
          values: prices,
          selectedValues: [
            prices[0],
            prices[prices.length - 1]
          ]
        }

      case FILTER_ID.LABELS:

        return {
          id: filterId,
          hideHeader: true,
          title: 'تگ ها',
          type: FILTER_TYPE.LIST,
          values: LABELS,
          selectedValues: []
        }


      default:
        break;
    }
  })

  return filters
}

export const applyFilter = (activeFilters, results) => {
  let finalResults = results

  activeFilters.forEach(filter => {
    switch (filter.id) {
      case FILTER_ID.NIGHTS_OF_STAY:

        finalResults = finalResults.filter(result => filter.selectedValues.includes(result.numberOfNightsOfStay))
        break;

      case FILTER_ID.HOTEL_STARS:

        finalResults = finalResults.filter(result =>
          result.hotelsStarRate.some(hotelStar => filter.selectedValues.includes(hotelStar))
        );
        break;

      case FILTER_ID.WENT_TIME:
        finalResults = finalResults.filter(result =>
          filter.selectedValues.some(filterItem => {
            const range = PARTS_OF_DAY[filterItem];
            return range && isWithinTimeRange(toTime(result.wentFlightDate), range);
          })
        );
        break;

      case FILTER_ID.RETURN_TIME:
        finalResults = finalResults.filter(result =>
          filter.selectedValues.some(filterItem => {
            const range = PARTS_OF_DAY[filterItem];
            return range && isWithinTimeRange(toTime(result.returnFlightDate), range);
          })
        );
        break;

      case FILTER_ID.AIRLINE:

        finalResults = finalResults.filter(result =>
          result.airLines.some(airline => filter.selectedValues.includes(airline.airLineCode))
        );
        break;

      case FILTER_ID.PRICE_RANGE:
        finalResults = finalResults.filter(result => filter.selectedValues[1] >= result.totalPrice && result.totalPrice >= filter.selectedValues[0])

        break;

      case FILTER_ID.LABELS:
        const selectedLabels = new Set(filter.selectedValues);
        finalResults = finalResults.filter(result => result.labels.some(label => selectedLabels.has(label.id)))

        break;
      default:
        break;
    }
  })


  return finalResults
}
